import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ApplicationVersionService } from '../../../business-services/application-version.service';
import Quill from 'quill';

@Component({
  selector: 'app-edit-application-version',
  templateUrl: './edit-application-version.component.html',
})
export class EditApplicationVersionComponent implements OnInit {
  @Input() applicationVersionId :number;
  @Input() latestVersionNumber:string;
  response:any;
  editApplicationVersionForm: FormGroup;
  quill: Quill;
  options = {
    toolbar: {
      container: [
        [{'undo':'Undo'}, {'redo': 'Redo'}],
        [{'direction': 'rtl'}, 'blockquote'],
        [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }, { 'header': 4 }],
        ['bold', 'italic', 'strike'],
        [{'script': 'super'}, {'script': 'sub'}],
        ['link'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['clean']
      ],
      handlers: {
        redo() {
          this.quill.history.redo();
        },
        undo() {
          this.quill.history.undo();
        }
      }
    },
    history: {delay: 500, maxStack: 500, userOnly: true}
  };
  constructor(
    private readonly activeModal : NgbActiveModal,
    private readonly formBuilder: FormBuilder,
    private readonly spinner: NgxSpinnerService,
    private readonly translate: TranslateService,
    private readonly toaster: ToastrService,
    private readonly ApplicationVersionService : ApplicationVersionService,
  ) { }

  ngOnInit(): void {
    this.editApplicationVersionForm = this.formBuilder.group({
      versionNumber: [null, [Validators.required]],
      releaseNote:[null,[Validators.required]],
      internalReleaseNote:[null,[Validators.required]]
    });
    this.getApplicationVersionById();
  }
  get cpf() {
    return this.editApplicationVersionForm.controls;
  }
  getApplicationVersionById(){
    this.ApplicationVersionService.getApplicationVersionById(this.applicationVersionId).then(response => {
      if (response) {
        this.response = response.responseObject;
        this.editApplicationVersionForm.patchValue(
          {
            "versionNumber":response.responseObject.versionNo,
            "releaseNote":response.responseObject.releaseNote,
            "internalReleaseNote":response.responseObject.internalReleaseNote
          }
        )
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        // This is intentional
      }
    })
  }
  editApplicationVersion(){
    this.spinner.show();
    const viewModel = {
      versionNumber: this.cpf.versionNumber.value,
      releaseNote: this.cpf.releaseNote.value,
      internalReleaseNote: this.cpf.internalReleaseNote.value
    }
    let addModel = this.ModelMapping(viewModel);
    this.ApplicationVersionService.editApplicationVersion(addModel).then(response => {
      if (response) {
        this.spinner.hide();
        let EditedVersion = this.translate.instant("lblVersionEdited");
        this.toaster.success(EditedVersion);
        this.activeModal.close({ success: true });
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        this.spinner.hide();
      }
   this.spinner.hide();
    })
  }
  ModelMapping(result:any){
        let single = Object();
        single.versionNo = result.versionNumber;
        single.releaseNote = result.releaseNote;
        single.internalReleaseNote = result.internalReleaseNote;
        single.Id = this.applicationVersionId;
        single.CreatedDate = this.response.createdDate
        return single;
      }
  OnClose(){
    this.activeModal.close({success:false})
  }
  ngOnDestroy(): void {
 // This is intentional
  }

}
